let authConfig: {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
} = {};

export function configureAuth(config: {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
}): void {
  authConfig = config;
}

export function getAuthConfig(): {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
} {
  return authConfig;
}

export async function authFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const headers = new Headers(init?.headers);

  if (authConfig.getAccessToken) {
    try {
      const token = await authConfig.getAccessToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
    } catch (error) {
      console.error('Error getting access token:', error);
    }
  }

  // Always set X-Instance-Id header, with fallback if not configured
  const instanceId = authConfig.instanceId || 'default-instance';
  headers.set('X-Instance-Id', instanceId);

  return fetch(input, {
    ...init,
    headers,
  });
}
